<template>
	<main-tabs :links="links">
		<keep-alive>
			<router-view></router-view>
		</keep-alive>
	</main-tabs>
</template>

<script>
	export default {
		data() {
			return {
				links: [{
					to: {
						path: '/newtest/basic'
					},
					label: '测款广告数据'
				}, {
					to: {
						path: '/newtest/advance'
					},
					label: '进阶测款'
				}]
			}
		}
	}
</script>
